import cookies from 'js-cookie';
import { defaultMemoize as memoizeOne } from 'reselect';

import { COOKIE_NAME, COOKIE_PUBLIC, COOKIE_SECURED } from './constants';

/**
 * Informs GTM if loaded page is secured or public. GTM according to this loads 3rd party scripts.
 */
const setGoogleAnalyticsCookie = memoizeOne((secured: boolean) => {
	cookies.set(COOKIE_NAME, secured ? COOKIE_SECURED : COOKIE_PUBLIC);
});

export default setGoogleAnalyticsCookie;
